import { getNetworkTrackingPropertyGroup } from 'app/dealer/utils';
import { trackAction } from 'app/shared/utils/tracking';

import { DealersInsightsLevelActionTypes } from '../../constants';

// NOTE: using static strings so tracking script can pick up this data for the TRACKING doc

export const NETWORK_TRACKING_ACTIONS = {
  NETWORK_TAB_SELECTED: DealersInsightsLevelActionTypes.SET_LEVEL,
};
/**
 * Required params to track a filtered network level action
 *
 * @typedef {Object} NetworkLevelTrackingParams
 * @property {import('../../../../../../../account/Network/reducer').Network} network
 * @property {'NETWORK_TAB_SELECTED'} action
 */

/**
 * @param {NetworkLevelTrackingParams} param0
 * @returns {void}
 */
export const trackFilteredNetwork = ({ network, actionType }) => {
  const trackingNetwork = getNetworkTrackingPropertyGroup(network);
  switch (actionType) {
    case NETWORK_TRACKING_ACTIONS.NETWORK_TAB_SELECTED:
      trackAction(
        'dashboard_navigation_network',
        {
          category: 'dealer_portal',
          description: 'user clicks on Network tab to see statistics on network level',
        },
        trackingNetwork,
      );
      break;
    default:
      break;
  }
};
